import styles from "./ProductFilter.module.scss";
import { CustomContainer } from "../../atoms/DependencyHelper";
import React, { useState, useRef, useEffect } from "react";
import SearchBoxAutoSuggest from "../../molecules/SearchBoxAutoSuggest/SearchBoxAutoSuggest"

const ProductFilter = ({
	closeRequired = true,
	className,
    onSearchTextSelect,
    handleError,
    isEligible,
    qualifyLabel,
    brands,
}) => {
    const [searchText, setSearchText] = useState("");
    const [acceptedSearchText, setAcceptedSearchText] = useState({});
    const searchBoxRef = useRef();

    useEffect(() => {
        if(searchText !== ""  && searchText == acceptedSearchText.label) {
            onSearchTextSelect(true, acceptedSearchText);
            if(searchBoxRef.current && searchBoxRef.current.clearText) {
                searchBoxRef.current.clearText();
            }
        }
    },[acceptedSearchText])

    const handleSearchTextChange = (val) => {
        setSearchText(val);
    }

    const handleSearchSelect = (val) => {
        let brandId = [];
        if(val.brandName) {
            brandId = brands.filter((brand) => 
                brand.label.toLowerCase().indexOf(val.brandName.toLowerCase()) > -1
            );
        } else {
            val.brandName = "";
        }
        val['brandId']= brandId.length > 0 ? brandId[0].value : "";
        setSearchText(val.label);
        setAcceptedSearchText(val);
    }

	return (
        <>
            <CustomContainer className={`${styles["search-container"]} ${className} d-none d-lg-block`}>     
                <p className={`${styles["filter-heading"]}`} id="filter-by-product-heading">Filter by product</p>
                <SearchBoxAutoSuggest
                    closeRequired={closeRequired}
                    handleSearchSelect={handleSearchSelect}
                    handleSearchTextChange={handleSearchTextChange}
                    ref={searchBoxRef}
                    handleFilterError={handleError}
                    showAffordabilityLabel={isEligible}
                    qualifyLabel={qualifyLabel}
                />
            </CustomContainer>
        </>
	);
};

export default ProductFilter;
